module.exports = __webpack_public_path__ + "static/media/icon-chevron-left.c8c9d47e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/icon-chevron-left.svg
// module id = 2866
// module chunks = 0